export default {
  subscriptionPricing: null,
  payment: {
    activeMethod: '',
  },
  uploader: {
    options: {
      visible: false,
    },
  },
  showUploadInProgressWarning: false,
};
